import React from 'react'
import PropTypes from 'prop-types'
import { Avatar, Button } from '@codecraftkit/theme'

/** Asks before replacing the picture with the chosen avatar. */
export const ProfilePictureConfirmAvatarAlert = ({ avatarSelected, item, updateImg, onClose, loading }) => (
  <div className='grid justify-items-center gap-4 p-8'>
    <Avatar
      src={avatarSelected?.url}
      name={item?.username}
      size='xl'
      className='w-[150px] h-[150px] shadow-[2px_2px_4px_0_rgba(0,0,0,0.5)]'
    />
    <p className='text-center text-[1.8em]'>Are you sure?</p>
    <p className='text-center text-gray-500'>This action cannot be undone</p>
    <div className='flex gap-4 mt-4'>
      <Button size='xs' onClick={onClose} colorScheme='red' variant='outline'>Cancel</Button>
      <Button
        size='xs'
        colorScheme='green'
        isLoading={loading}
        onClick={() => updateImg(avatarSelected?.url)}
      >
        {loading ? 'Saving' : 'Select'}
      </Button>
    </div>
  </div>
)

ProfilePictureConfirmAvatarAlert.propTypes = {
  avatarSelected: PropTypes.object,
  item: PropTypes.object,
  updateImg: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  loading: PropTypes.bool
}
